import React, { Fragment } from "react";
import Footer from "../../component/Other/Footer";
import Navbar from "../../component/Other/Navbar";
const About = (props) => {
    return (
        <Fragment>
            <div className="overflow-hidden">
                <Navbar type="light" />
                <section>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-xl-8 my-auto">
                                <div className="wrapper__point mb-3">
                                    <div className="dot"></div>
                                    <h5 className="mb-0 ml-2 color__blue semi-bold font__size--16 text__16-1024">About PavilionManager</h5>
                                </div>
                                <h1 className="bold font__size--40 text__48-1024 text__48-md text__48-sm ">A Multi-Tenant Platform <br className="d-none d-xl-block" /> For Capital Projects</h1>
                                <p className="normal font__size--16 text__16-1024  color__gray-2 mb-4">PavilionManager helps organizations run construction projects from <br className="d-none d-xl-block" /> one place, bringing admins, workers, milestones, tasks, ledgers, <br className="d-none d-xl-block" /> procurement, client artefacts and collaboration together.</p>
                                <a href="#!" className="btn btn__outlined--green font__size--16 text__16-1024 semi-bold color__black h__black no__opacity shadow rounded__50">See the platform</a>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="bg__blue">
                    <div className="container">
                        <div className="text-center mb-5">
                            <h2 className="bold font__size--40 text__40-1024 text__40-md text__40-mm color__white">What PavilionManager Connects</h2>
                            <p className="normal font__size--16 text__16-1024 color__white mb-0">Every project carries the operational, financial and collaboration context <br /> teams need to move from plan to proof.</p>
                        </div>
                        <div className="wrapper__list-archivment d-flex flex-wrap align-items-center justify-content-center">
                            <div className="item mb-4 mb-xl-0 d-flex align-items-center">
                                <div className="d-flex align-items-center">
                                    <img src="./../images/award.png" alt="" />
                                    <h5 className="mb-0 semi-bold font__size--40 text__40-1024 text__40-md text__40-mm color__white ml-3">Org</h5>
                                </div>
                                <p className="normal font__size--16 text__16-1024 color__white mb-0 ml-3">Tenant and <br /> member roles</p>
                            </div>
                            <div className="item mb-4 mb-xl-0 d-flex align-items-center">
                                <div className="d-flex align-items-center">
                                    <img src="./../images/close-circle.png" alt="" />
                                    <h5 className="mb-0 semi-bold font__size--40 text__40-1024 text__40-md text__40-mm color__white ml-3">Site</h5>
                                </div>
                                <p className="normal font__size--16 text__16-1024 color__white mb-0 ml-3">Project and <br /> worker control</p>
                            </div>
                            <div className="item mb-4 mb-xl-0 d-flex align-items-center">
                                <div className="d-flex align-items-center">
                                    <img src="./../images/star.png" alt="" />
                                    <h5 className="mb-0 semi-bold font__size--40 text__40-1024 text__40-md text__40-mm color__white ml-3">BoQ</h5>
                                </div>
                                <p className="normal font__size--16 text__16-1024 color__white mb-0 ml-3">Quantities and <br /> progress</p>
                            </div>
                            <div className="item mb-4 mb-xl-0 d-flex align-items-center">
                                <div className="d-flex align-items-center">
                                    <img src="./../images/happyemoji.png" alt="" />
                                    <h5 className="mb-0 semi-bold font__size--40 text__40-1024 text__40-md text__40-mm color__white ml-3">Live</h5>
                                </div>
                                <p className="normal font__size--16 text__16-1024 color__white mb-0 ml-3">Chats and <br /> updates</p>
                            </div>
                        </div>
                    </div>
                </section>

                <section>
                    <div className="container text-center">
                        <h5 className="semi-bold font__size--20 text__20-1024 mb-4">Made for project owners, delivery teams and clients</h5>
                        {/* <div className="wrapper__logo-wrap flex-xl-nowrap flex-wrap d-flex align-items-center justify-content-center">
                            <img className="mb-3" src="./../images/Company logo.png" alt="" />
                            <img className="mb-3" src="./../images/Company logo (1).png" alt="" />
                            <img className="mb-3" src="./../images/Company logo (2).png" alt="" />
                            <img className="mb-3" src="./../images/Company logo (3).png" alt="" />
                            <img className="mb-3" src="./../images/Company logo (4).png" alt="" />
                            <img className="mb-3" src="./../images/Company logo (5).png" alt="" />
                        </div> */}
                    </div>
                </section>

                <Footer />
            </div >
        </Fragment >
    );
};

export default About;
